import { useState } from "react";
import { motion } from "framer-motion";
import { Camera, Shield, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import ArchitectureDiagram from "@/components/demo/ArchitectureDiagram";
import FaceMatchSimulator from "@/components/demo/FaceMatchSimulator";

export default function FacialRecognitionDemo() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("architecture");

  return (
    <div className="min-h-screen bg-slate-950" data-testid="facial-recognition-demo">
      <header className="sticky top-0 z-50 bg-slate-950/90 backdrop-blur-xl border-b border-slate-800">
        <div className="max-w-[1600px] mx-auto px-6 flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <Shield className="w-6 h-6 text-cyan-400" />
            <div>
              <h1 className="text-base font-bold text-white leading-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
                AI Facial Recognition — ANPR Integration
              </h1>
              <p className="text-[10px] text-slate-500">Command & Control Intelligence | BharatIntelliAI</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => navigate("/demo/dashboard")} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs text-slate-400 hover:text-cyan-400 hover:bg-slate-800 transition-all" data-testid="back-to-demos">
              <ArrowLeft size={14} /> Back
            </button>
            <span className="text-xs text-slate-500 hidden md:block">{user?.email}</span>
          </div>
        </div>
      </header>

      <div className="max-w-[1600px] mx-auto px-6 py-6">
        {/* Tabs */}
        <div className="flex items-center gap-2 mb-8">
          {[
            { id: "architecture", label: "System Architecture", icon: Camera },
            { id: "simulation", label: "Live Simulation", icon: Shield },
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              data-testid={`tab-${tab.id}`}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all ${
                activeTab === tab.id
                  ? "bg-cyan-500 text-slate-950"
                  : "bg-slate-900 text-slate-400 border border-slate-800 hover:border-cyan-500/30"
              }`}
            >
              <tab.icon size={15} />
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "architecture" && <ArchitectureDiagram />}
        {activeTab === "simulation" && <FaceMatchSimulator />}
      </div>
    </div>
  );
}
